/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Modal, Radio, Backdrop, Grid, Tooltip, CircularProgress, FormControlLabel, RadioGroup, Divider } from '@mui/material';
import { Rnd } from 'react-rnd';
import Notification from '../../shared/notification-modal';
import { closeIconBlack } from '../../shared/assets/images';
import SelectComponent from '../../shared/form-components/select/select-component';
import './system-units.scss';
import {
  unitsForFlow,
  unitsForFlux,
  unitsForTemp,
  unitsForPressure,
  unitsForPower,
  unitsForVolume,
  defaultUnitValues,
  defaultModalOptions,
} from '../../shared/constantVariable';
import { isObjectEmpty, checkLocalStorageValue, getEmailUserType } from '../../shared/helper';
import { saveWinflowsFileContent } from '../../shared/api/url-helper';
import { convertUnitValues_temp, convertUnitValues_flow, convertUnitValues_power, convertUnitValues_pressure, convertUnitValues_flux, convertUnitValues_volume } from '../../shared/conversion-helper/unitConversion';
import { encrypt_data } from '../../shared/utils';
import { ExecuteContext } from '../Flow';

const Units = (props) => {
  const {
    visibleUnits,
    handleCloseUnits,
    feedItem,
    visibleDefaultUnits,
    translateObject
  } = props;
  const [unitObj, setUnitObj] = useState(defaultUnitValues);
  const [stdUnit, setStdUnit] = useState('us');
  const reportData = useContext(ExecuteContext);
  const [loading] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  // function to check ubit type: US/ internatioal or custom
  const fetchUnits = async (fetch = false) => {
    const destroyParam = localStorage.getItem('system-units');
    const parsedData = JSON.parse(destroyParam);
    if (!fetch && isObjectEmpty(parsedData)) {
      setUnitObj(parsedData);
      if (parsedData.temp === '°F' && parsedData.pressure === 'psi' && parsedData.flow === 'gpm' &&
        parsedData.flux === 'gfd' && parsedData.power === 'hp' && parsedData.volume === 'gal') {
        setStdUnit('us');
      } else {// eslint-disable-next-line
        if (parsedData.temp === '°C' && parsedData.pressure === 'bar' && parsedData.flow === 'm3/hr' &&
          parsedData.flux === 'lmh' && parsedData.power === 'kW' && parsedData.volume === 'm3') {
          setStdUnit('international');
        } else
          setStdUnit('custom');
      }
    } else {
      setStdUnit('custom');
      setUnitObj(defaultUnitValues);
    }
  };

  useEffect(() => {
    fetchUnits(false);
  }, [feedItem]);
  useEffect(() => {
    // Retrieve unit settings from localStorage
    const unit_set_dict = JSON.parse(localStorage.getItem('unit_set_dict'));
    const default_system_units = JSON.parse(localStorage.getItem('default_unit_set_dict'));
    // Check conditions to update the application state with default system units
    if (visibleDefaultUnits && checkLocalStorageValue('default_unit_set_dict') && JSON.stringify(unit_set_dict) === JSON.stringify(default_system_units)) {
      // Set the standard unit type
      setStdUnit(default_system_units.type);
      // Update the application state with unit settings
      setUnitObj({
        temp: default_system_units.Temperature,
        pressure: default_system_units.Pressure,
        flow: default_system_units['Volume Flow'],
        flux: default_system_units.Flux,
        power: default_system_units.Power,
        volume: default_system_units['Liquid Volume'],
      });
      // Update localStorage with the default system units
      localStorage.setItem('unit_set_dict', JSON.stringify(default_system_units));
      localStorage.setItem('system-units', JSON.stringify({
        temp: default_system_units.Temperature,
        pressure: default_system_units.Pressure,
        flow: default_system_units['Volume Flow'],
        flux: default_system_units.Flux,
        power: default_system_units.Power,
        volume: default_system_units['Liquid Volume'],
      }));
    }
  }, []); // Dependency array is empty, so this effect runs only once after the initial render.

  const onClose = () => {
    setUnitObj(defaultUnitValues);
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleCloseUnits(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseUnits();
    };
  };

  const handleSelectUnits = (e) => {
    setStdUnit('custom');
    setIsShowErrorMessage(true);
    const { name, value } = e.target;
    setUnitObj({ ...unitObj, [name]: value });
  };

  const handleChangeStdUnit = (e) => {
    setStdUnit(e.target.value);

    if (e.target.value === 'us') {
      setUnitObj({
        temp: '°F',
        pressure: 'psi',
        flow: 'gpm',
        flux: 'gfd',
        power: 'hp',
        volume: 'gal',
      });
    }

    if (e.target.value === 'international') {
      setUnitObj({
        temp: '°C',
        pressure: 'bar',
        flow: 'm3/hr',
        flux: 'lmh',
        power: 'kW',
        volume: 'm3',
      });
    }

    if (e.target.value === 'custom') {
      setUnitObj({
        temp: '°C',
        pressure: 'atm',
        flow: 'gpm',
        flux: 'gfd',
        power: 'kW',
        volume: 'gal',
      });
    }

  };

  const handleOk = () => {
    let flow_val = '';
    let pressure_val = '';
    let power_val = '';
    if (localStorage.getItem('system-units')) {
      const data = JSON.parse(localStorage.getItem('system-units'));
      localStorage.setItem('previous_flow_unit', data.flow);
      localStorage.setItem('previous_pressure_unit', data.pressure);
      localStorage.setItem('previous_power_unit', data.power);
      flow_val = data.flow;
      pressure_val = data.pressure;
      power_val = data.power;
    } else {
      localStorage.setItem('previous_flow_unit', 'gpm');
      localStorage.setItem('previous_pressure_unit', 'atm');
      localStorage.setItem('previous_power_unit', 'kW');
      flow_val = 'gpm';
      pressure_val = 'atm';
      power_val = 'kW';
    }
    localStorage.setItem('system-units', JSON.stringify(unitObj));
    handleCloseUnits();
    // Stream data conversion Start Edit by Chandrashekhar 11/01/2023
    const jsonData = JSON.parse(localStorage.getItem('stream_ouput_data'));
    const sysUnit = JSON.parse(localStorage.getItem('system-units'));
    const uniSetDict = JSON.parse(localStorage.getItem('unit_set_dict'));
    const specifyFlowUnits = JSON.parse(localStorage.getItem('feed_flow_dict'));
    const specifyProductlowUnits = JSON.parse(localStorage.getItem('product_flow_dict'));

    if (specifyFlowUnits) {
      let val = 0;
      const previous_flow_unit = localStorage.getItem('previous_flow_unit');
      const feed_key = Object.keys(specifyFlowUnits.feed_flow.feed_value);
      val = convertUnitValues_flow(specifyFlowUnits.feed_flow.feed_value[feed_key[0]], previous_flow_unit, sysUnit.flow);
      specifyFlowUnits.feed_flow.feed_value[feed_key[0]] = val;
      localStorage.setItem('feed_flow_dict', JSON.stringify(specifyFlowUnits));

      const feed_dict = JSON.parse(localStorage.getItem('flow_dict'));
      feed_dict[feed_key[0]] = convertUnitValues_flow(val, sysUnit.flow, 'm3/s');
      localStorage.setItem('flow_dict', JSON.stringify(feed_dict));

    }
    if (specifyProductlowUnits) {
      let val = 0;
      const pro_val = specifyProductlowUnits.product_flow.product_value;
      if (!pro_val.product_flow_selected) {
        const previous_flow_unit = localStorage.getItem('previous_flow_unit');
        val = convertUnitValues_flow(Number(pro_val[pro_val.selected_radio_value]), previous_flow_unit, sysUnit.flow);
        specifyProductlowUnits.product_flow.product_value[pro_val.selected_radio_value] = val;
        localStorage.setItem('product_flow_dict', JSON.stringify(specifyProductlowUnits));

        const feed_dict = JSON.parse(localStorage.getItem('flow_dict'));
        Object.keys(JSON.parse(localStorage.getItem('flow_dict'))).map((ele) => {
          if (ele !== 'feed_flow_flag')
            feed_dict[ele] = 0;
        });
        feed_dict[pro_val.selected_radio_value] = convertUnitValues_flow(val, sysUnit.flow, 'm3/s');
        localStorage.setItem('flow_dict', JSON.stringify(feed_dict));
      }
    }
    if (jsonData) {
      const streameDataKey = Object.keys(jsonData);
      streameDataKey.forEach(element => {
        const fData = convertUnitValues_temp(jsonData[element].prop_dict.temp, uniSetDict.Temperature, sysUnit.temp);
        jsonData[element].temp = parseFloat(fData);
        jsonData[element].prop_dict.temp = parseFloat(fData);
        const fData1 = convertUnitValues_flow(jsonData[element].prop_dict.flow, uniSetDict['Volume Flow'], sysUnit.flow);
        jsonData[element].flow = parseFloat(fData1);
        jsonData[element].prop_dict.flow = parseFloat(fData1);
        const fData2 = convertUnitValues_pressure(jsonData[element].prop_dict.press, uniSetDict.Pressure, sysUnit.pressure);
        jsonData[element].press = parseFloat(fData2);
        jsonData[element].prop_dict.press = parseFloat(fData2);
        const fData3 = convertUnitValues_pressure(jsonData[element].sat_indices.osmotic_pressure, uniSetDict.Pressure, sysUnit.pressure);
        jsonData[element].sat_indices.osmotic_pressure = parseFloat(fData3);
      });
      localStorage.setItem('stream_ouput_data', JSON.stringify(jsonData));
    }
    // Stream data conversion End
    // Explorer Data Conversion Start
    const roOutputData = JSON.parse(localStorage.getItem('ro_ouput_data'));
    if (roOutputData) {
      const roOutPutDataKeys = Object.keys(roOutputData);
      roOutPutDataKeys.forEach((element) => {
        if (roOutputData[element] && (['CLRO', 'RO_HP', 'RO'].indexOf(roOutputData[element].unit_type) >= 0)) {
          if (roOutputData[element].output_user && roOutputData[element].output_user.sat_indices && roOutputData[element].output_user.sat_indices.osmotic_pressure) {
            const eleosmotic_pressure = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.sat_indices.osmotic_pressure, uniSetDict.Pressure, sysUnit.pressure));
            roOutputData[element].output_user.sat_indices.osmotic_pressure = eleosmotic_pressure;
          }
          if (roOutputData[element].output_user && roOutputData[element].output_user.system_data && roOutputData[element].output_user.system_data.length) {
            roOutputData[element].output_user.system_data.forEach((ele, index) => {
              if (roOutputData[element].output_user.system_data[index].name !== 'System') {
                const temp = parseFloat(convertUnitValues_temp(roOutputData[element].output_user.system_data[index].temp, uniSetDict.Temperature, sysUnit.temp));
                roOutputData[element].output_user.system_data[index].temp = temp;
                const feed_press = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.system_data[index].feed_press, uniSetDict.Pressure, sysUnit.pressure));
                roOutputData[element].output_user.system_data[index].feed_press = feed_press;
                const avg_flux = parseFloat(convertUnitValues_flux(roOutputData[element].output_user.system_data[index].avg_flux, uniSetDict.Flux, sysUnit.flux));
                roOutputData[element].output_user.system_data[index].avg_flux = avg_flux;
                const max_flux = parseFloat(convertUnitValues_flux(roOutputData[element].output_user.system_data[index].max_flux, uniSetDict.Flux, sysUnit.flux));
                roOutputData[element].output_user.system_data[index].max_flux = max_flux;
              } else {
                const temp = parseFloat(convertUnitValues_temp(roOutputData[element].output_user.system_data[index].temp, uniSetDict.Temperature, sysUnit.temp));
                roOutputData[element].output_user.system_data[index].temp = temp;
              }
            });
          }
          if (roOutputData[element].output_user && roOutputData[element].output_user.stage && roOutputData[element].output_user.stage.length) {
            roOutputData[element].output_user.stage.forEach((ele, index) => {
              // stage changes start
              const feed_flow = parseFloat(convertUnitValues_flow(roOutputData[element].output_user.stage[index].feed_flow, uniSetDict['Volume Flow'], sysUnit.flow));
              roOutputData[element].output_user.stage[index].feed_flow = feed_flow;
              const conc_flow = parseFloat(convertUnitValues_flow(roOutputData[element].output_user.stage[index].conc_flow, uniSetDict['Volume Flow'], sysUnit.flow));
              roOutputData[element].output_user.stage[index].conc_flow = conc_flow;
              const perm_flow = parseFloat(convertUnitValues_flow(roOutputData[element].output_user.stage[index].perm_flow, uniSetDict['Volume Flow'], sysUnit.flow));
              roOutputData[element].output_user.stage[index].perm_flow = perm_flow;
              const feed_press = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].feed_press, uniSetDict.Pressure, sysUnit.pressure));
              roOutputData[element].output_user.stage[index].feed_press = feed_press;
              const delta_press = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].delta_press, uniSetDict.Pressure, sysUnit.pressure));
              roOutputData[element].output_user.stage[index].delta_press = delta_press;
              const feed_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].feed_pi, uniSetDict.Pressure, sysUnit.pressure));
              roOutputData[element].output_user.stage[index].feed_pi = feed_pi;
              const conc_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].conc_pi, uniSetDict.Pressure, sysUnit.pressure));
              roOutputData[element].output_user.stage[index].conc_pi = conc_pi;
              const perm_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].perm_pi, uniSetDict.Pressure, sysUnit.pressure));
              roOutputData[element].output_user.stage[index].perm_pi = perm_pi;
              const avg_flux = parseFloat(convertUnitValues_flux(roOutputData[element].output_user.stage[index].avg_flux, uniSetDict.Flux, sysUnit.flux));
              roOutputData[element].output_user.stage[index].avg_flux = avg_flux;
              // stage changes End
              // Module conversion Start
              if (ele.pres_vessels && ele.pres_vessels[0] && ele.pres_vessels[0].module.length) {
                ele.pres_vessels[0].module.forEach((m, ind) => {
                  const mfeed_flow = parseFloat(convertUnitValues_flow(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_flow, uniSetDict['Volume Flow'], sysUnit.flow));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_flow = mfeed_flow;
                  const mperm_flow = parseFloat(convertUnitValues_flow(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].perm_flow, uniSetDict['Volume Flow'], sysUnit.flow));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].perm_flow = mperm_flow;
                  const mfeed_press = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_press, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_press = mfeed_press;
                  const mnet_press = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].net_press, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].net_press = mnet_press;
                  const mdp = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].dp, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].dp = mdp;
                  const mfeed_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_pi, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].feed_pi = mfeed_pi;
                  const mconc_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].conc_pi, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].conc_pi = mconc_pi;
                  const mperm_pi = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].perm_pi, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].perm_pi = mperm_pi;
                  const mflux = parseFloat(convertUnitValues_flux(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].flux, uniSetDict.Flux, sysUnit.flux));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].flux = mflux;
                  const mosmotic_pressure = parseFloat(convertUnitValues_pressure(roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].sat_indices.osmotic_pressure, uniSetDict.Pressure, sysUnit.pressure));
                  roOutputData[element].output_user.stage[index].pres_vessels[0].module[ind].sat_indices.osmotic_pressure = mosmotic_pressure;
                });
              }
              // Module conversion End
            });
          }
        }
      });
    }
    if (reportData && reportData.reportData && reportData.reportData.report_dict && reportData.reportData.report_dict.clro_elem_summary && reportData.reportData.report_dict.clro_elem_summary['CLRO Unit ID']) {
      const clro_elem_summaryData = reportData.reportData.report_dict.clro_elem_summary;
      clro_elem_summaryData['CLRO Unit ID'].forEach((clroele) => {
        const ElementsData = clro_elem_summaryData[clroele].Elements;
        Object.keys(ElementsData).forEach((elements) => {
          Object.keys(ElementsData[elements]).forEach((sub) => {
            const Conc_Flow = parseFloat(convertUnitValues_flow(ElementsData[elements][sub]['Conc Flow'], uniSetDict['Volume Flow'], sysUnit.flow));
            ElementsData[elements][sub]['Conc Flow'] = Conc_Flow;
            const Feed_Flow = parseFloat(convertUnitValues_flow(ElementsData[elements][sub]['Feed Flow'], uniSetDict['Volume Flow'], sysUnit.flow));
            ElementsData[elements][sub]['Feed Flow'] = Feed_Flow;
            const Perm_Flow = parseFloat(convertUnitValues_flow(ElementsData[elements][sub]['Perm Flow'], uniSetDict['Volume Flow'], sysUnit.flow));
            ElementsData[elements][sub]['Perm Flow'] = Perm_Flow;
            const Feed_Press = parseFloat(convertUnitValues_pressure(ElementsData[elements][sub]['Feed Press'], uniSetDict.Pressure, sysUnit.pressure));
            ElementsData[elements][sub]['Feed Press'] = Feed_Press;
          });
        });
      });
    }
    if (reportData && reportData.reportData && reportData.reportData.report_dict && reportData.reportData.report_dict.clro_overview) {
      const clroOverview = reportData.reportData.report_dict.clro_overview;
      Object.keys(clroOverview).forEach((clroEle) => {
        Object.keys(clroOverview[clroEle].units).forEach((ele) => {
          if (ele.toLowerCase() === 'flow') {
            const flowunit = clroOverview[clroEle].units[ele].split('/pv')[0];
            Object.keys(clroOverview[clroEle][ele]).forEach((clroVal) => {
              const clroFlowVal = parseFloat(convertUnitValues_flow(clroOverview[clroEle][ele][clroVal], flowunit, sysUnit.flow));
              clroOverview[clroEle][ele][clroVal] = clroFlowVal;
            });
          } else if (ele.toLowerCase() === 'cl system volume') {
            const clroVolumnVal = parseFloat(convertUnitValues_volume(clroOverview[clroEle][ele], clroOverview[clroEle].units[ele], sysUnit.volume));
            clroOverview[clroEle][ele] = clroVolumnVal;
          }
        });
        clroOverview[clroEle].units.Flow = `${sysUnit.flow}/pv`;
        clroOverview[clroEle].units['CL System Volume'] = sysUnit.volume;
      });
    }
    let ro_dict = localStorage.getItem('ro-dict');
    if (ro_dict) {
      ro_dict = JSON.parse(localStorage.getItem('ro-dict'));
      ro_dict = ro_dict.ro;
      Object.keys(ro_dict).forEach((ele) => {
        if (ro_dict[ele].roInputDetails.splitPermeate) {
          const splitPermeate = convertUnitValues_flow(Number(ro_dict[ele].roInputDetails.splitPermeate), flow_val, sysUnit.flow);
          ro_dict[ele].roInputDetails.splitPermeate = splitPermeate.toFixed(2);
        }
        if (ro_dict[ele]['grid-data'].length > 0) {
          ro_dict[ele]['grid-data'].forEach((e) => {
            const interStageBoostPressure = convertUnitValues_pressure(Number(e.interStageBoostPressure), pressure_val, sysUnit.pressure);
            e.interStageBoostPressure = interStageBoostPressure;
            const interStagePressureLoss = convertUnitValues_pressure(Number(e.interStagePressureLoss), pressure_val, sysUnit.pressure);
            e.interStagePressureLoss = interStagePressureLoss;
            const permeatePressure = convertUnitValues_pressure(Number(e.permeatePressure), pressure_val, sysUnit.pressure);
            e.permeatePressure = permeatePressure;
          });
        }
      });
      localStorage.setItem('ro-dict', JSON.stringify({ ro: ro_dict }));
    }
    let ro_dict_temp = localStorage.getItem('ro-dict-temp');
    if (ro_dict_temp) {
      ro_dict_temp = JSON.parse(localStorage.getItem('ro-dict-temp'));
      ro_dict_temp = ro_dict_temp.ro;
      Object.keys(ro_dict_temp).forEach((ele) => {
        if (ro_dict_temp[ele].roInputDetails.splitPermeate) {
          const splitPermeate = convertUnitValues_flow(Number(ro_dict_temp[ele].roInputDetails.splitPermeate), flow_val, sysUnit.flow);
          ro_dict_temp[ele].roInputDetails.splitPermeate = splitPermeate.toFixed(2);
        }
        if (ro_dict_temp[ele]['grid-data'].length > 0) {
          ro_dict_temp[ele]['grid-data'].forEach((e) => {
            const interStageBoostPressure = convertUnitValues_pressure(Number(e.interStageBoostPressure), pressure_val, sysUnit.pressure);
            e.interStageBoostPressure = interStageBoostPressure;
            const interStagePressureLoss = convertUnitValues_pressure(Number(e.interStagePressureLoss), pressure_val, sysUnit.pressure);
            e.interStagePressureLoss = interStagePressureLoss;
            const permeatePressure = convertUnitValues_pressure(Number(e.permeatePressure), pressure_val, sysUnit.pressure);
            e.permeatePressure = permeatePressure;
          });
        }
      });
      localStorage.setItem('ro-dict-temp', JSON.stringify({ ro: ro_dict_temp }));
    }
    // update CF when user change the unit
    const cf_output_dict = localStorage.getItem('cf-output-dict');
    if (cf_output_dict) {
      let data = JSON.parse(cf_output_dict);
      data = data['cf-output'];
      Object.values(data).forEach((ele) => {
        const actual_flow_per_t = convertUnitValues_flow(Number(ele.output_user.actual_flow_per_t), flow_val, sysUnit.flow);
        ele.output_user.actual_flow_per_t = Number(actual_flow_per_t);
        const flow_per_t = convertUnitValues_flow(Number(ele.output_user.flow_per_t), flow_val, sysUnit.flow);
        ele.output_user.flow_per_t = Number(flow_per_t);
        const dp = convertUnitValues_pressure(Number(ele.output_user.dp), pressure_val, sysUnit.pressure);
        ele.output_user.dp = Number(dp);
      });
      const obj = { 'cf-output': data };
      localStorage.setItem('cf-output-dict', JSON.stringify(obj));
    }
    // update checmical dosing when user change the unit
    const cd_output_dict = localStorage.getItem('cd-output-dict');
    if (cd_output_dict) {
      const data = JSON.parse(cd_output_dict);
      Object.values(data).forEach((ele) => {
        Object.values(ele).forEach((e) => {
          const volume_rate = convertUnitValues_flow(Number(e.output_user.volume_rate), flow_val, sysUnit.flow);
          e.output_user.volume_rate = Number(volume_rate);
          const supplied_volume = convertUnitValues_flow(Number(e.output_user.supplied_volume), flow_val, sysUnit.flow);
          e.output_user.supplied_volume = Number(supplied_volume);
          const metered_volume = convertUnitValues_flow(Number(e.output_user.metered_volume), flow_val, sysUnit.flow);
          e.output_user.metered_volume = Number(metered_volume);
          const safety_factor_volume = convertUnitValues_flow(Number(e.output_user.safety_factor_volume), flow_val, sysUnit.flow);
          e.output_user.safety_factor_volume = Number(safety_factor_volume);
        });
      });
      localStorage.setItem('cd-output-dict', JSON.stringify(data));
    }
    // update EDI-OUTPUT-DICT Start
    const edi_output_dict = localStorage.getItem('edi-output-dict');
    if (edi_output_dict) {
      const data = JSON.parse(edi_output_dict);
      Object.values(data).forEach((parentEle) => {
        Object.values(parentEle).forEach((ele) => {
          Object.keys(ele.output_user.calc_param).forEach((finalEle) => {
            let calcparam_val = ele.output_user.calc_param[finalEle];
            if (['product_flow_rate', 'feed_inlet', 'concentrate_bleed', 'electrode_bleed'].indexOf(finalEle) >= 0) {
              calcparam_val = convertUnitValues_flow(Number(calcparam_val), flow_val, sysUnit.flow);
            } else if (['feed_pressure', 'pred_pdt_outlet_pressure'].indexOf(finalEle) >= 0) {
              calcparam_val = convertUnitValues_pressure(Number(calcparam_val), pressure_val, sysUnit.pressure);
            } else if (['dcpower', 'acpower'].indexOf(finalEle) >= 0) {
              calcparam_val = convertUnitValues_power(Number(calcparam_val), power_val, sysUnit.power);
            }
            ele.output_user.calc_param[finalEle] = calcparam_val;
          });
        });
      });
      localStorage.setItem('edi-output-dict', JSON.stringify(data));
    }
    // update EDI-OUTPUT-DICT End
    localStorage.setItem('ro_ouput_data', JSON.stringify(roOutputData));
    // Explorer Data Conversion End
    localStorage.setItem('unit_set_dict', JSON.stringify({
      'Volume Flow': sysUnit.flow,
      'Pressure': sysUnit.pressure,
      'Temperature': sysUnit.temp,
      'Liquid Volume': sysUnit.volume,
      'Flux': sysUnit.flux,
      'Power': sysUnit.power
    }));
  };
  const handleSave = () => {
    // Retrieve the user email from session storage
    const userMailId = sessionStorage.getItem('user_email');
    const Country_name = sessionStorage.getItem('country');
    // Determine if the user is internal or external based on their email domain
    // const getUserType = userMailId.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
    // Define the payload with unit settings
    const payload_units = {
      'country': Country_name,
      'type': stdUnit,
      'Volume Flow': unitObj.flow,
      'Pressure': unitObj.pressure,
      'Temperature': unitObj.temp,
      'Liquid Volume': unitObj.volume,
      'Flux': unitObj.flux,
      'Power': unitObj.power
    };
    // Encrypt the payload data
    const encrypt_units = encrypt_data(payload_units);
    // Save the encrypted unit settings to a file and handle the response
    saveWinflowsFileContent(`units/${userMailId}`, userMailId, getEmailUserType(userMailId), encrypt_units).then(() => {
      // On success, show a success modal and update local storage with the unit settings
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        type: 'success',
        title: 'Success!',
        message: 'Default units have been saved successfully.',
        yesOrNo: false,
      });
      localStorage.setItem('default_unit_set_dict', JSON.stringify(payload_units));
      localStorage.setItem('unit_set_dict', JSON.stringify(payload_units));
      localStorage.setItem('system-units', JSON.stringify({
        temp: payload_units.Temperature,
        pressure: payload_units.Pressure,
        flow: payload_units['Volume Flow'],
        flux: payload_units.Flux,
        power: payload_units.Power,
        volume: payload_units['Liquid Volume'],
      }));
      // handleOk(); // Optionally handle additional logic on success
    }).catch(() => {
      // On error, show an error modal
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        type: 'error',
        title: 'Error',
        message: translateObject('Failed to load Default units.'),
        yesOrNo: false,
      });
    });
  };
  return (
    <Modal
      hideBackdrop
      open={visibleUnits}
      onClose={onClose}>
      <Box>
        <Rnd
          default={{
            width: '40%',
            x: ((window.innerWidth / 2) - ((36 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((60 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='33%'
          cancel='.no_drag, .MuiOutlinedInput-root'
          className='system-units-box box-model'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            style={{ background: '#d9dbde5c' }}
            open={loading}>
            <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
          </Backdrop>
          <Grid container className='units-grid-container'>
            <Grid item xs={12} className='model_header'>
              <span className='no_drag S_heading model_header_text'>{translateObject('Display Units')}</span>
              <div className='units-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={onClose}
                    style={{ width: '14px', padding: '11px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid container className='units-body-container' style={{ maxHeight: '70vh' }}>
              <Grid item xs={12} >
                <RadioGroup
                  row
                  className="radio-group-container no_drag"
                  value={stdUnit}
                  onChange={handleChangeStdUnit}
                >
                  <FormControlLabel
                    name="us"
                    value="us"
                    control={<Radio />}
                    label={translateObject('US')}
                    labelPlacement="end"
                    className='S_Regular'
                  />
                  <FormControlLabel
                    name="international"
                    value="international"
                    control={<Radio />}
                    label={translateObject('International')}
                    labelPlacement="end"
                    className='S_Regular'
                  />
                  <FormControlLabel
                    name="custom"
                    value="custom"
                    control={<Radio />}
                    label={translateObject('Custom')}
                    labelPlacement="end"
                    className='S_Regular'
                  />
                </RadioGroup>
              </Grid>
              <Grid item xs={12}>
                <div className="form-grid">
                  <div className="form-field w-48 ">
                    <span className="normal-font w-48 f-left no_drag S_Bold">{translateObject('Temperature')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForTemp}
                        className="custom-select-box no_drag"
                        name="temp"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                  <div className="form-field no_drag w-48 ">
                    <span className="normal-font w-48 f-left no_drag S_Bold">{translateObject('Pressure')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForPressure}
                        className="custom-select-box no_drag"
                        name="pressure"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                  <div className="form-field no_drag w-48 ">
                    <span className="normal-font w-48 f-left no_drag S_Bold">{translateObject('Flow')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForFlow}
                        className="custom-select-box no_drag"
                        name="flow"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                  <div className="form-field no_drag w-48">
                    <span className="normal-font w-48 f-left no_drag S_Bold">{translateObject('Flux')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForFlux}
                        className="custom-select-box no_drag"
                        name="flux"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                  <div className="form-field no_drag w-48">
                    <span className="normal-font w-48 f-left no_drag S_Bold">{translateObject('Power')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForPower}
                        className="custom-select-box"
                        name="power"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                  <div className="form-field no_drag w-48">
                    <span className="normal-font w-48 f-left">{translateObject('Volume')}</span>
                    <div className="system-unit-select">
                      <SelectComponent
                        handleChange={handleSelectUnits}
                        width='90%'
                        renderData={unitsForVolume}
                        className="custom-select-box"
                        name="volume"
                        valueObj={unitObj}
                        stdUnit={stdUnit}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12}><Divider /></Grid>
            <Grid container className='units_footer'>
              <Button
                size="small"
                variant="contained"
                className="btn-auto-width Primary_Default_Button"
                onClick={handleSave}
                style={{ marginRight: 20 }}
              >
                {translateObject('Save as Default')}
              </Button>
              <Button
                size="small"
                variant="contained"
                className="btn-auto-width Primary_Default_Button"
                onClick={handleOk}>
                {translateObject('OK')}
              </Button>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default Units;